import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

const MyAccountComponent = ({ me }) => {
  if (me) {
    return (
      <a href="/profile" className="nav-link">
        My Account
      </a>
    );
  }
  return (
    <a href="/login" className="nav-link">
      Login
    </a>
  );
};

MyAccountComponent.propTypes = {
  me: PropTypes.object,
};

const MyAccountApp = withRouter(connect(({ user }) => ({ me: user.me }))(MyAccountComponent));

export default MyAccountApp;
